/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, total: NonNullable<unknown> }} Api_Keys_Table_Showing_EntriesInputs */



/**
* | output |
* | --- |
* | "Showing {count} of {total} entries" |
*
* @param {Api_Keys_Table_Showing_EntriesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_keys_table_showing_entries = /** @type {((inputs: Api_Keys_Table_Showing_EntriesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Table_Showing_EntriesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Zeige ${i?.count} von ${i?.total} Einträgen`)
	return /** @type {LocalizedString} */ (`Showing ${i?.count} of ${i?.total} entries`)
});